import '@flatfile/agent-ui/styles.css'
import '@flatfile/baseline/styles.css'
import { MantineProvider, createTheme } from '@mantine/core'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { TranslationsProvider } from './providers/TranslationProvider'
import { QueryProvider } from './providers/query-client'
import './styles/globals.css'

const theme = createTheme({
  // You can customize the theme here if needed
})

if (
  import.meta.env.VITE_PUBLIC_POSTHOG_KEY &&
  import.meta.env.VITE_PUBLIC_POSTHOG_HOST
) {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
    enable_recording_console_log: true,
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <QueryProvider>
        <BrowserRouter>
          <TranslationsProvider>
            <MantineProvider theme={theme}>
              <App />
            </MantineProvider>
          </TranslationsProvider>
        </BrowserRouter>
      </QueryProvider>
    </PostHogProvider>
  </React.StrictMode>
)
